import { UI } from "@wwimmo/ui";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { ColorStyle } from "src/utils/Colors";
import { observer } from "mobx-react";
import * as Sentry from "@sentry/react";
import styles from "src/screens/orders/order/details/form/modal/ImageItemModal.module.css";

interface ImageItemModalProps {
    imageSource: string;
    isDisplayed: boolean;
    toggleDisplayImageModal: any;
}

const ImageItemModalBase = (props: ImageItemModalProps) => {
    const { t } = useTranslation();

    const { imageSource, isDisplayed, toggleDisplayImageModal } = props;

    const [isImageLoading, setIsImageLoading] = useState<boolean>(true);
    const [hadErrorLoadingImage, setHadErrorLoadingImage] = useState<boolean>(false);

    const onImageLoad = useCallback(() => {
        setIsImageLoading(false);
    }, []);

    const onImageError = useCallback(() => {
        setHadErrorLoadingImage(true);
        setIsImageLoading(false);
    }, []);

    return (
        <UI.Modal
            size="lg"
            show={isDisplayed}
            onClose={toggleDisplayImageModal}
            centered={true}
            className={styles.ImageModal}
        >
            <img src={imageSource} onLoad={onImageLoad} onError={onImageError} alt="" />

            {isImageLoading && imageSource ? <UI.RotatingSpinner noLogo={true} size={25} /> : undefined}

            {hadErrorLoadingImage ? (
                <div className={styles.ImageLoadingErrorContainer}>
                    <UI.Icon icon={UI.SVGIcon.CloseCircle} color={ColorStyle("danger")} size={40} className="mb-1" />
                    <span>{t("screens.tickets.form.notification.image_loading_error")}</span>
                </div>
            ) : undefined}
        </UI.Modal>
    );
};

export const ImageItemModal = Sentry.withProfiler(observer(ImageItemModalBase));
